import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
}

const BookingReference = ({ helper, ...rest }: Props) => {
  const name = 'booking_ref'
  const label = 'Booking reference number'

  return <TextInput name={name} label={label} helper={helper} {...rest} />
}

export default BookingReference
